export default new class ScrollTopButtonService {
    private readonly scrollTopButton: HTMLImageElement;

    constructor() {
        this.scrollTopButton = this.createScrollTopButton();
    }

    public init(): void {
        this.scrollTopButton.addEventListener("click", () => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        });

        window.addEventListener("scroll", () => {
            if (window.scrollY > 0) {
                this.scrollTopButton.classList.add("fade-in");
                this.scrollTopButton.classList.remove("fade-out");
            } else {
                this.scrollTopButton.classList.add("fade-out");
                this.scrollTopButton.classList.remove("fade-in");
            }
        });
    }

    private createScrollTopButton(): HTMLImageElement {
        const scrollTopImage = document.createElement("img");

        scrollTopImage.src = "/css/image/slidetop.png";
        scrollTopImage.style.position = "fixed";
        scrollTopImage.style.bottom = "10px";
        scrollTopImage.style.right = "10px";
        scrollTopImage.style.width = "50px";
        scrollTopImage.style.cursor = "pointer";
        scrollTopImage.style.zIndex = "1000000";
        scrollTopImage.style.display = "none";
        scrollTopImage.classList.add("scroll-to-top");
        scrollTopImage.setAttribute("alt", "Nahoru");

        document.body.appendChild(scrollTopImage);

        const checkModalVisibility = (): void => {
            const modalExists = document.querySelector<HTMLDivElement>(".modal-content") !== null;
            scrollTopImage.style.display = modalExists ? "none" : "block";
        };

        checkModalVisibility();

        const observer = new MutationObserver(() => {
            checkModalVisibility();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return scrollTopImage;
    }
}();
